module.exports = "<p *ngFor=\"let msg of messages\" [innerHTML]=\"msg\"></p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/field-error-message/field-error-message.component.html
// module id = 1565
// module chunks = 18